import { Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { Banner } from './banner'
import { useListingData } from '../../context/listing-data'

export const RequiredActionBanner = () => {
  const { t } = useTranslation()
  const { listingPending, loading } = useListingData()

  if (loading) return null

  if (listingPending)
    return (
      <Banner title="Pending review">
        <Text tone="caution" size="small">
          {t('Please check back within 1-2 business days. No action is required.')}
        </Text>
      </Banner>
    )

  return null
}
